// Import model
import { StartProjectAppointmentInitiateOmwsmsRequest } from '../models/StartProjectAppointmentInitiateOmwsmsRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartProjectAppointmentInitiateOmwsmsRequest - handles JSON serialization and deserialization with type validation
 */
export class StartProjectAppointmentInitiateOmwsmsRequestSerializer {
  /**
   * Deserializes a JSON string into a StartProjectAppointmentInitiateOmwsmsRequest instance
   */
  static deserialize(json: string): StartProjectAppointmentInitiateOmwsmsRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartProjectAppointmentInitiateOmwsmsRequest instance
   */
  static fromObject(obj: any): StartProjectAppointmentInitiateOmwsmsRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartProjectAppointmentInitiateOmwsmsRequest');
    }


    const instance: StartProjectAppointmentInitiateOmwsmsRequest = {
      phoneNumber: obj['PhoneNumber'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartProjectAppointmentInitiateOmwsmsRequest instances
   */
  static deserializeArray(json: string): StartProjectAppointmentInitiateOmwsmsRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartProjectAppointmentInitiateOmwsmsRequest instance to a JSON string
   */
  static serialize(instance: StartProjectAppointmentInitiateOmwsmsRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartProjectAppointmentInitiateOmwsmsRequest instance to a plain object
   */
  static toObject(instance: StartProjectAppointmentInitiateOmwsmsRequest): any {
    return {
      'PhoneNumber': instance.phoneNumber,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartProjectAppointmentInitiateOmwsmsRequest instances to a JSON string
   */
  static serializeArray(instances: StartProjectAppointmentInitiateOmwsmsRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
